'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isSurveyGroupItem = (item) => {
    const items = item.items;
    return items !== undefined && items.length > 0;
};

exports.isSurveyGroupItem = isSurveyGroupItem;
//# sourceMappingURL=survey-item.js.map
